import React, { useEffect } from "react";
import {
  BookOpen,
  Banknote,
  User,
  CreditCard,
  CalendarCheck2,
  Receipt,
  ShieldCheck,
} from "lucide-react";
import clsx from "clsx";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getCourseById } from "../../State/Course/Action";
import { useDispatch } from "react-redux";

const CourseCheckout = () => {
  const { courseId } = useParams();
  const learner = JSON.parse(localStorage.getItem("learner"));
  const course = useSelector((store) => store.course.course);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCourseById(courseId));
  }, [courseId, dispatch]);
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 to-white px-4 py-10">
      <div className="w-full max-w-3xl bg-white rounded-3xl shadow-2xl p-10 space-y-8">
        <h1 className="text-3xl font-bold text-center text-indigo-700">
          <CreditCard className="inline-block w-8 h-8 mr-2 text-indigo-600" />
          Course Checkout
        </h1>

        <div className="space-y-6">
          <div className="flex items-center justify-between border-b pb-4">
            <div className="flex items-center space-x-3">
              <BookOpen className="w-6 h-6 text-indigo-500" />
              <span className="text-lg font-medium text-gray-700">Course</span>
            </div>
            <span className="text-base text-gray-800">{course.name}</span>
          </div>

          {/* <div className="flex items-center justify-between border-b pb-4">
            <div className="flex items-center space-x-3">
              <User className="w-6 h-6 text-indigo-500" />
              <span className="text-lg font-medium text-gray-700">Customer</span>
            </div>
            <span className="text-base text-gray-800">{customer.name}</span>
          </div> */}

          <div className="flex items-center justify-between border-b pb-4">
            <div className="flex items-center space-x-3">
              <Banknote className="w-6 h-6 text-indigo-500" />
              <span className="text-lg font-medium text-gray-700">
                Course Price
              </span>
            </div>
            <span className="text-base text-gray-800">₹ {course.price}</span>
          </div>

          <div className="flex items-center justify-between border-b pb-4">
            <div className="flex items-center space-x-3">
              <CalendarCheck2 className="w-6 h-6 text-indigo-500" />
              <span className="text-lg font-medium text-gray-700">
                Enrollment Date
              </span>
            </div>
            <span className="text-base text-gray-800">
              {new Date().toLocaleDateString()}
            </span>
          </div>

          <div className="flex items-center justify-between pt-6 pb-4 border-t-2 border-dashed border-indigo-300">
            <div className="flex items-center space-x-3">
              <Receipt className="w-6 h-6 text-indigo-600" />
              <span className="text-xl font-semibold text-gray-800">
                Total Amount
              </span>
            </div>
            <span className="text-xl font-bold text-indigo-700">
              ₹ {course.price}
            </span>
          </div>
        </div>

        <button className="w-full mt-6 bg-indigo-600 text-white font-semibold py-3 rounded-xl hover:bg-indigo-700 transition flex items-center justify-center space-x-2 shadow-md">
          <ShieldCheck className="w-5 h-5" />
          <span>Proceed to Secure Payment</span>
        </button>
      </div>
    </div>
  );
};

export default CourseCheckout;
